export default "__VITE_ASSET__7dfch80x__"